module.exports = __webpack_public_path__ + "img/testimonials_grid.f220f404.png";